import { create } from 'zustand';
export var useToast = create(function (set) { return ({
    toast: null,
    setToast: function (toast) { return set(function () { return ({ toast: toast }); }); },
}); });
